import { Paper, Table, TableBody, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import React, { FC } from "react"
import * as styles from "./styles"
import { TableRowsLoader } from "./tableRowsLoader"

type TableProps = {
  title?: string
  loading: boolean
  headers: React.ReactNode
  alert?: React.ReactNode
  items?: React.ReactNode
  loadingRows?: number
  loadingCellsPerRow?: number
}

const View: FC<TableProps> = ({ title, loading, alert, headers, items, loadingRows = 5, loadingCellsPerRow = 5 }) => {
  return (
    <>
      {title ? <Typography sx={styles.title}>{title}</Typography> : null}
      <TableContainer component={Paper} sx={styles.tableBox}>
        {!loading && alert}
        <Table aria-label='customized table'>
          <TableHead sx={styles.tableHead}>
            <TableRow sx={styles.tableHeadRow}>{headers}</TableRow>
          </TableHead>
          <TableBody>
            {loading && <TableRowsLoader totalRows={loadingRows} cellsPerRow={loadingCellsPerRow} />}
            {!loading && items}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}

export default View
